import React from "react";
import Container from "react-bootstrap/Container";

const Footer = (props) => {
  return (
    <footer id="contact" className="site-footer py-5 text-center">
      <Container>{props.children}</Container>
    </footer>
  );
};

export default Footer;
